import { render, staticRenderFns } from "./Area_Info.vue?vue&type=template&id=5a1bde29&"
import script from "./Area_Info.vue?vue&type=script&lang=js&"
export * from "./Area_Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports